
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component<BackButton>({})
export default class BackButton extends Vue {
    onClick() {
        this.$router.back()
    }
}
